module.exports = __webpack_public_path__ + "img/code.34d334f.png";